import React, {Component} from 'react'
import Link from 'gatsby-link'
import {Header} from '../components/Header'
import {Footer} from '../components/Footer'
import {InfoSection} from '../components/InfoSection/'
import {Signup} from '../components/Signup'
import {FeaturedArtists} from '../components/FeaturedArtists'
import {ArtistGrid} from '../components/ArtistGrid'
import {OverviewBlocks} from '../components/OverviewBlocks'
import {LinkBox} from '../components/LinkBox'
import {AuditionExcerpts} from '../components/AuditionExcerpts'
import logoSrc from '../../static/logo_color.png'
import './2018-chamber-series.css'

import en from '../data-en'
import cn from '../data-cn'
import locale from '../locale'
let data = { en, cn };
let localizedData = () => data[locale.getLocale()];
let chamber_series_page = localizedData().chamber_series_page;

class ChamberSeriesPage extends Component {
  render() {

    let overviewSizes = [
      this.props.data.trainingResidencyImage.sizes,
      this.props.data.concertTourImage.sizes,
    ];

    let teachingArtistSizes = [
      this.props.data.qingLiImage.sizes,
      this.props.data.yongMaImage.sizes,
      this.props.data.guangChenImage.sizes,
    ];

    let studentArtistSizes = [
      this.props.data.yuboCaoImage.sizes,
      this.props.data.yiqingFuImage.sizes,
      this.props.data.hankeLiImage.sizes,
      this.props.data.yixiangWangImage.sizes,
      this.props.data.junyiLiImage.sizes,
      this.props.data.yujieZengImage.sizes,
      this.props.data.zhihongLiImage.sizes,
      this.props.data.tianchengZhuImage.sizes,
      this.props.data.yaxinDangImage.sizes,
      this.props.data.zishuXieImage.sizes,
      this.props.data.ningZhangImage.sizes,
      this.props.data.huibinZouImage.sizes,
      this.props.data.jingrenChengImage.sizes,
      this.props.data.yichuanWangImage.sizes,
      this.props.data.jingyanWangImage.sizes,
      this.props.data.yichengGongImage.sizes,
      this.props.data.jihanZhangImage.sizes,
      this.props.data.zhaotingLiuImage.sizes,
      this.props.data.tianqiWuImage.sizes,
      this.props.data.puyuanChenImage.sizes,
      this.props.data.zhouDiImage.sizes
    ];

    return (
      <div>
        <Header src={logoSrc} data={localizedData().header}></Header>

        <div className="margin-large">

          <InfoSection
            title = {chamber_series_page.overview.title}
            description = {chamber_series_page.overview.description}
            sizes = {this.props.data.chamberSeriesImage.sizes}>
          </InfoSection>

          <br></br><br></br>

          <OverviewBlocks
            blocks = {chamber_series_page.overview_blocks}
            sizes = {overviewSizes}>
          </OverviewBlocks>

          <hr></hr>

          <FeaturedArtists
            data={chamber_series_page.teaching_artists}
            sizes = {teachingArtistSizes}>
          </FeaturedArtists>

          <hr></hr>


          <ArtistGrid
            data= {chamber_series_page.student_artists}
            sizes = {studentArtistSizes}
            isShort = {true}>
          </ArtistGrid>

        </div>
        <Footer></Footer>
      </div>
    );
  }
}

export default ChamberSeriesPage;

export const pageQuery = graphql`
  query ChamberSeriesQuery {
    chamberSeriesImage: imageSharp(id: { regex: "/yale_performance/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    trainingResidencyImage: imageSharp(id: { regex: "/2018_training_residency/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    concertTourImage: imageSharp(id: { regex: "/2018_concert_tour/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    qingLiImage: imageSharp(id: { regex: "/qing_li/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    yongMaImage: imageSharp(id: { regex: "/yong_ma/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    guangChenImage: imageSharp(id: { regex: "/guang_chen/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    yuboCaoImage: imageSharp(id: { regex: "/yubo_cao/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    yiqingFuImage: imageSharp(id: { regex: "/yiqing_fu/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    hankeLiImage: imageSharp(id: { regex: "/hanke_li/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    yixiangWangImage: imageSharp(id: { regex: "/yixiang_wang/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    junyiLiImage: imageSharp(id: { regex: "/junyi_li/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    yujieZengImage: imageSharp(id: { regex: "/yujie_zeng/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes
      }
    },
    zhihongLiImage: imageSharp(id: { regex: "/zhihong_li/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    tianchengZhuImage: imageSharp(id: { regex: "/tiancheng_zhu/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    yaxinDangImage: imageSharp(id: { regex: "/yaxin_dang/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    zishuXieImage: imageSharp(id: { regex: "/zishu_xie/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    ningZhangImage: imageSharp(id: { regex: "/ning_zhang/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    huibinZouImage: imageSharp(id: { regex: "/huibin_zou/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    jingrenChengImage: imageSharp(id: { regex: "/jingren_cheng/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    yichuanWangImage: imageSharp(id: { regex: "/yichuan_wang/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    jingyanWangImage: imageSharp(id: { regex: "/jingyan_wang/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    yichengGongImage: imageSharp(id: { regex: "/yicheng_gong/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    jihanZhangImage: imageSharp(id: { regex: "/jihan_zhang/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    zhaotingLiuImage: imageSharp(id: { regex: "/zhaoting_liu/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    tianqiWuImage: imageSharp(id: { regex: "/tianqi_wu/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    puyuanChenImage: imageSharp(id: { regex: "/puyuan_chen/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    zhouDiImage: imageSharp(id: { regex: "/zhou_di/" }) {
      sizes(maxWidth: 800 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
  }
`;



// WEBPACK FOOTER //
// ./src/pages/2018-chamber-series.jsx